import type { FlagDefinition } from '../flagDefinitions'

export type { FlagDefinition }

// Flags with no LaunchDarkly entry yet — for pre-LD prototyping only, never load-bearing.
// Add entries here to test a flag-gated UI state before creating the real LD flag, e.g.:
//   { key: 'showNewOnboardingBanner', type: 'boolean', default: false }
export const localFlagDefinitions: readonly FlagDefinition[] = [
    { key: 'showOnboardingV2', type: 'boolean', default: false, route: '/onboarding/about-you' },
    { key: 'showApplicationV2', type: 'boolean', default: false, route: '/application-test/account-type' },
    { key: 'showBffAuth', type: 'boolean', default: false, route: '/' },
]
